import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../services/event-emitter.service';
import { TeamMembersService } from '../../services/team-members.service';
import { Roles } from '../../models/roles';

@Component({
  standalone: false,
  selector: 'app-team-member-popup',
  templateUrl: './team-member-popup.component.html',
  styleUrl: './team-member-popup.component.scss',
})
export class TeamMemberPopupComponent implements OnInit {
  title;
  type = '';
  formGroup: FormGroup;
  teamMember;
  allRoles = Roles;
  roles = [Roles.Manager, Roles.Rider];
  disableButton = false;

  constructor(
    public bsModalRef: BsModalRef,
    private teamMembersService: TeamMembersService,
    private eventEmitterService: EventEmitterService,
  ) {}

  async ngOnInit() {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = new FormGroup({
      firstname: new FormControl(
        this.teamMember ? this.teamMember.firstname : '',
      ),
      lastname: new FormControl(
        this.teamMember ? this.teamMember.lastname : '',
      ),
      email: new FormControl(
        this.teamMember ? this.teamMember.email : '',
        Validators.required,
      ),
      password: new FormControl(
        this.teamMember ? this.teamMember.password : '',
      ),
      role: new FormControl(
        this.teamMember ? this.teamMember.role : '',
        Validators.required,
      ),
    });
    this.updatePasswordValidators();
  }

  updatePasswordValidators() {
    if (!this.teamMember) {
      if (this.formGroup.get('role').value != Roles.Rider) {
        this.formGroup.get('password')?.setValidators(Validators.required);
      } else {
        this.formGroup.get('password')?.clearValidators();
      }
    } else {
      this.formGroup.get('password')?.clearValidators();
    }
    this.formGroup.get('password')?.updateValueAndValidity();
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  setRole(event) {
    this.formGroup.get('role').setValue(event.value);

    this.updatePasswordValidators();
    if (this.formGroup.get('role').value != Roles.Rider) {
      this.formGroup.get('firstname')?.setValidators(Validators.required);
      this.formGroup.get('lastname')?.setValidators(Validators.required);
    } else {
      this.formGroup.get('firstname')?.clearValidators();
      this.formGroup.get('lastname')?.clearValidators();
    }
    this.formGroup.get('firstname')?.updateValueAndValidity();
    this.formGroup.get('lastname')?.updateValueAndValidity();
  }

  buttonClicked() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    if (this.disableButton == true) {
      return;
    }
    this.disableButton = true;

    if (this.type === 'new-team-member') {
      this.teamMembersService.createTeamMember(this.formGroup.value).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllTeamMembers();
          this.closeModal();
          this.disableButton = false;
        },
        (error) => {
          console.log('error:');
          console.log(error);
          this.disableButton = false;
        },
      );
    }
    if (this.type === 'edit-team-member') {
      this.teamMembersService
        .updateTeamMember(this.teamMember.id, this.formGroup.value)
        .subscribe(
          (response) => {
            console.log('response:');
            console.log(response);
            this.eventEmitterService.callAllTeamMembers();
            this.closeModal();
            this.disableButton = false;
          },
          (error) => {
            console.log('error:');
            console.log(error);
            this.disableButton = false;
          },
        );
    }
  }
}
